document.addEventListener('DOMContentLoaded', function() {
  const MAX_VARIANTS = 10;
  const checkoutButton = document.getElementById('checkout');
  const items = document.querySelectorAll('.cart-item');
  
  if (items.length > MAX_VARIANTS) {
    const titleWrapper = document.querySelector(".title-wrapper-with-link");
    if (titleWrapper && !document.querySelector(".caution")) {
      const caution = document.createElement("div");
      caution.className = "caution";
      caution.textContent = "1注文あたりの購入可能商品数は"+MAX_VARIANTS+"件までです。";
      titleWrapper.insertAdjacentElement("afterend", caution);
    }
  }

  if (checkoutButton) {
    checkoutButton.addEventListener('click', function(event) {
      const items = document.querySelectorAll('.cart-item');
      if (items.length <= MAX_VARIANTS) return;

      if (items.length > MAX_VARIANTS) {
        event.preventDefault(); 
        alert(`1注文あたりの購入可能商品数は${MAX_VARIANTS}件までです。\n上限を超えている分はカートから削除してください。`);
      }

    })
  }
});